<template>
  <div class="dsfa-sc-block" :style="blockStyle">
    <div class="dsfa-sc-block-bg" :style="bgStyle"></div>
    <!-- 这里放图标/图片/动画div -->
    <div class="dsfa-sc-block-content">
      <slot></slot>
      <div class="dsfa-sc-block-title">
        {{ title }}
      </div>
      <div class="dsfa-sc-block-data">
        <DsfSCCountTo class="dsfa-sc-block-data-number" :num="number"></DsfSCCountTo>
        <div class="dsfa-sc-block-data-unit">{{ unit }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DsfSCBlock",
  props: {
    title: {
      type: String,
      default: "",
    },
    number: {
      type: [String, Number],
      default: "",
    },
    unit: {
      type: String,
      default: "",
    },
    bgColor: {
      type: String,
      default: "transparent",
    },
    align: {
      type: String,
      default: "left",
    },
  },
  data() {
    return {
      testNumber: null,
    };
  },
  computed: {
    blockStyle() {
      return {
        "text-align": this.align,
      };
    },
    bgStyle() {
      return {
        "background-color": this.bgColor,
      };
    },
  },
  components: {},
  created() {},
  methods: {},
};
</script>
